// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/diffstat.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/diffstat.proto.
 */
export const file_pull_requests_v1_diffstat: GenFile = /*@__PURE__*/
  fileDesc("Ch9wdWxsX3JlcXVlc3RzL3YxL2RpZmZzdGF0LnByb3RvEhdnaXRodWIucHVsbF9yZXF1ZXN0cy52MSJHChBEaWZmc3RhdFJlc3BvbnNlEjMKCGRpZmZzdGF0GAEgASgLMiEuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuRGlmZnN0YXQipAEKCERpZmZzdGF0EjAKC2xpbmVzX2FkZGVkGAEgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSMgoNbGluZXNfZGVsZXRlZBgCIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjIKDWxpbmVzX2NoYW5nZWQYAyABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZWIGcHJvdG8z", [file_google_protobuf_wrappers]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/diffstat
 *
 * Defined by PullRequests::PageData::SharedController#diffstat.
 *
 * Wrapper types are used because the controller rescues GitRPC::Error and
 * renders the response with nil values, which must be representable as JSON
 * `null` distinctly from `0`.
 *
 * @generated from message github.pull_requests.v1.DiffstatResponse
 */
export type DiffstatResponse = Message<"github.pull_requests.v1.DiffstatResponse"> & {
  /**
   * @generated from field: github.pull_requests.v1.Diffstat diffstat = 1;
   */
  diffstat?: Diffstat;
};

/**
 * Describes the message github.pull_requests.v1.DiffstatResponse.
 * Use `create(DiffstatResponseSchema)` to create a new message.
 */
export const DiffstatResponseSchema: GenMessage<DiffstatResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_diffstat, 0);

/**
 * @generated from message github.pull_requests.v1.Diffstat
 */
export type Diffstat = Message<"github.pull_requests.v1.Diffstat"> & {
  /**
   * @generated from field: google.protobuf.Int32Value lines_added = 1;
   */
  linesAdded?: number;

  /**
   * @generated from field: google.protobuf.Int32Value lines_deleted = 2;
   */
  linesDeleted?: number;

  /**
   * @generated from field: google.protobuf.Int32Value lines_changed = 3;
   */
  linesChanged?: number;
};

/**
 * Describes the message github.pull_requests.v1.Diffstat.
 * Use `create(DiffstatSchema)` to create a new message.
 */
export const DiffstatSchema: GenMessage<Diffstat> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_diffstat, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(DiffstatResponseSchema, "716e72f67e93")
registerSchemaHash(DiffstatSchema, "d6fc65a372b9")
